import { styled } from '@mui/material';

export const PreferedDateList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  margin: 0
});

export const PreferedDateListItem = styled('li')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  '& > div:first-of-type': {
    display: 'flex',
    width: '38%'
  },
  marginTop: '8px'
});
